import { quranStructure, TOTAL_QURAN_VERSES } from './constants';

// Every ayah has a number from 1 to 6236 running straight through the Quran.
// A single integer per ayah is what makes the reading log compact enough to
// keep in localStorage and cheap to intersect over a date range.

// Cumulative verse count before each surah: offsets[3] is the number of ayahs
// that precede Surah 3.
const offsets = (() => {
  const table = { };
  let running = 0;
  quranStructure.forEach((surah) => {
    table[surah.number] = running;
    running += surah.totalVerses;
  });
  return table;
})();

// Verse 0 is the Bismillah heading a surah, not an ayah of it, so it has no
// number and never counts towards a goal.
export const globalAyahNumber = (surah, verse) => {
  if (!(surah >= 1 && surah <= 114)) return null;
  if (!(verse >= 1)) return null;
  const surahInfo = quranStructure[surah - 1];
  if (verse > surahInfo.totalVerses) return null;
  return offsets[surah] + verse;
};

export const positionFromGlobal = (ayahNumber) => {
  if (!(ayahNumber >= 1 && ayahNumber <= TOTAL_QURAN_VERSES)) return null;
  for (let i = quranStructure.length - 1; i >= 0; i -= 1) {
    const surah = quranStructure[i];
    if (ayahNumber > offsets[surah.number]) {
      return { surah: surah.number, verse: ayahNumber - offsets[surah.number] };
    }
  }
  return null;
};

// First and last ayah number of a surah, inclusive.
export const surahRange = (surah) => {
  const info = quranStructure[surah - 1];
  if (!info) return null;
  return { first: offsets[surah] + 1, last: offsets[surah] + info.totalVerses };
};

// Where each of the 30 juz begins, in the standard Hafs division.
const JUZ_STARTS = [
  [1, 1], [2, 142], [2, 253], [3, 93], [4, 24], [4, 148], [5, 82], [6, 111],
  [7, 88], [8, 41], [9, 93], [11, 6], [12, 53], [15, 1], [17, 1], [18, 75],
  [21, 1], [23, 1], [25, 21], [27, 56], [29, 46], [33, 31], [36, 28], [39, 32],
  [41, 47], [46, 1], [51, 31], [58, 1], [67, 1], [78, 1]
];

const juzFirstAyah = JUZ_STARTS.map(([surah, verse]) => globalAyahNumber(surah, verse));

// First and last ayah number of a juz, inclusive.
export const juzRange = (juz) => {
  if (!(juz >= 1 && juz <= 30)) return null;
  return {
    first: juzFirstAyah[juz - 1],
    last: juz === 30 ? TOTAL_QURAN_VERSES : juzFirstAyah[juz] - 1
  };
};

export const juzOf = (surah, verse) => {
  const ayah = globalAyahNumber(surah, verse);
  if (!ayah) return null;
  for (let juz = 30; juz >= 1; juz -= 1) {
    if (ayah >= juzFirstAyah[juz - 1]) return juz;
  }
  return null;
};

export const TOTAL_SURAHS = 114;
export const TOTAL_JUZ = 30;
export { TOTAL_QURAN_VERSES };
